import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { setPrevPage, setNextPage } from '../../../redux/slices/appStateSlice';

const NumberOfChildrenLogic = ({ fields, deps }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (deps.spouse && fields.partnerDetailsPage?.value) {
      dispatch(setPrevPage(fields.partnerDetailsPage?.value?.href));
    } else {
      dispatch(setPrevPage(fields.partnerOrChildrenPage?.value?.href));
    }
    if (deps?.children?.length === 1) {
      dispatch(setNextPage(fields.childDetailsPage?.value?.href));
    } else {
      dispatch(setNextPage(fields.childrenDetailsPage?.value?.href));
    }
  }, [deps]);

  return <></>;
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    deps: state.quoteData?.prospectDetails?.dependents,
  };
};
export default connect(mapStateToProps)(NumberOfChildrenLogic);
